import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-trinka-in-other-apps',
  templateUrl: './trinka-in-other-apps.component.html',
  styleUrls: ['./trinka-in-other-apps.component.scss']
})
export class TrinkaInOtherAppsComponent {

  @Input() title: string = '在其他應用程式中使用 Trinka';

  appsList = [
    {
      class: 'trinkaCloud',
      route: '/trinkacloud',
      imgSrc: '/assets/images/Other_apps_TrinkaCloud.svg',
      imgAlt: 'trinka cloud',
      title: 'Cloud'
    },
    {
      class: 'windowsApp',
      route: '/windows-desktop-app',
      imgSrc: '/assets/images/native-app/windows-icon.svg',
      imgAlt: 'window app',
      title: 'Windows App'
    },
    {
      class: 'wordPlugin',
      route: '/wordplugin',
      imgSrc: '/assets/images/Others_App_MSWord.svg',
      imgAlt: 'ms word',
      title: 'MS Word 外掛程式'
    },
    {
      class: 'browserPlugin',
      route: '/browser-plugin',
      imgSrc: '/assets/images/other_Apps_browser.svg',
      imgAlt: 'browser-plugin',
      title: '瀏覽器外掛程式'
    },
    {
      class: 'enterpriseApp',
      route: '/enterprise',
      imgSrc: '/assets/images/Other_Apps_enterprise.svg',
      imgAlt: 'enterprise',
      title: '企業方案',
      subtitle: '(API、JavaScript 嵌入與在地端部署)'
    }
  ];

}
